import { Controller } from "@hotwired/stimulus"

// Champ « tiers lié » : recherche d'une fiche personne ou entreprise, le choix remplit la valeur
// cachée « People::Person:<id> ».
export default class extends Controller {
  static targets = ["query", "value", "results"]
  static values = { url: String }

  disconnect() { clearTimeout(this.timer) }

  search() {
    this.valueTarget.value = ""
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("q", this.queryTarget.value.trim())
      this.resultsTarget.src = url.toString()
    }, 200)
  }

  pick(event) {
    const { value, label } = event.currentTarget.dataset
    this.valueTarget.value = value
    this.queryTarget.value = label
    this.resultsTarget.innerHTML = ""
  }
}
